import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router';
import { notification, PageTitle, pageTitles } from '../../utils/constants';
import { openNotification } from '../../store/commonSlice';
import { useDispatch } from 'react-redux';

const Header = () => {
	const [headerContent, setHeaderContent] = useState('');
	const location = useLocation();
	const dispatch = useDispatch();

	const headerFragment =
		'/content/experience-fragments/vizio/us/en/new-header-2022/master/jcr:content/root.plain.html';
	const headerScript = '/etc.clientlibs/vizio/clientlibs/2022-header.min.js';

	const showTermsOfServiceError = (event: any) => {
		event.preventDefault();
		dispatch(
			openNotification({
				type: 'ERROR',
				heading: 'Error',
				body: notification.message.termsOfServicesError
			})
		);
	};

	const showConfirmEmailError = (event: any) => {
		event.preventDefault();
		dispatch(
			openNotification({
				type: 'ERROR',
				heading: 'Error',
				body: notification.message.emailConfirmError
			})
		);
	};

	const showUpdatePasswordError = (event: any) => {
		event.preventDefault();
	};

	useEffect(() => {
		const pageTitle = pageTitles.find(
			(pageTitle: PageTitle) => pageTitle.path === location.pathname
		);

		if (pageTitle) {
			document.title = `${pageTitle.title} | VIZIO`;
		}

		const userIcon: any = document.querySelector('.nav_bar__account a');

		if (location.pathname === '/terms-of-service') {
			if (userIcon) {
				userIcon.href = '#';
				userIcon.addEventListener('click', showTermsOfServiceError);
			}
		} else if (location.pathname === '/confirm-email') {
			if (userIcon) {
				userIcon.href = '#';
				userIcon.addEventListener('click', showConfirmEmailError);
			}
		} else if (location.pathname === '/password-update') {
			if (userIcon) {
				userIcon.href = '#';
				userIcon.addEventListener('click', showUpdatePasswordError);
			}
		}

		return () => {
			if (userIcon) {
				userIcon.href = '/en/account';
				userIcon.removeEventListener('click', showTermsOfServiceError);
				userIcon.removeEventListener('click', showConfirmEmailError);
				userIcon.removeEventListener('click', showUpdatePasswordError);
			}
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, headerContent]);

	useEffect(() => {
		axios.get(headerFragment).then((response) => {
			setHeaderContent(response.data);
			const imageElements = document.querySelectorAll('img[data-src]');

			if (imageElements.length) {
				imageElements.forEach((imageElement: any) => {
					imageElement.setAttribute('src', imageElement.dataset.src);
				});
			}
			loadExternalScript();
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadExternalScript = () => {
		const script = document.createElement('script');
		script.src = headerScript;
		script.async = false;
		document.body.appendChild(script);
	};

	return (
		<>
			<div dangerouslySetInnerHTML={{ __html: headerContent }}></div>
		</>
	);
};

export default Header;
